//#region src/locale.ts
var e = {
	"ar-SA": "ar",
	"de-DE": "de",
	"en-GB": "en",
	"es-ES": "es",
	"fr-FR": "fr",
	"id-ID": "id_ID",
	"ja-JP": "ja",
	"ko-KR": "ko",
	"pl-PL": "pl",
	"pt-PT": "pt",
	"ru-RU": "ru",
	"th-TH": "th",
	"tr-TR": "tr",
	"vi-VN": "vi",
	"zh-CN": "zh"
};
function t(t) {
	return e[t];
}
//#endregion
export { t as toWidgetLocale };
